// components/tabs/Surface3DTab.jsx
// PC-CVAE 三维相面预测

import Plot3D from '../viz/Plot3D';
import { useSolPred } from '../../hooks/useSolPredStore';

export default function Surface3DTab() {
  const {
    selectedSystem, allData3D, phaseList,
    autoRotate, setAutoRotate,
    selectedPoint, setSelectedPoint,
  } = useSolPred();

  return (
    <div className="canvas-card full fade-in">
      <div className="canvas-header">
        <div>
          <div className="canvas-title">三维相面 · Predicted Solubility Surface</div>
          <div className="canvas-subtitle">
            PC-CVAE 在 (w₁, T) → w₂_sat 平面上的连续预测面 · 实验点叠加
          </div>
        </div>
        <div className="canvas-tools">
          <button
            className={`tool-btn ${autoRotate ? 'active' : ''}`}
            onClick={() => setAutoRotate(v => !v)}
          >{autoRotate ? '⏸ 停止旋转' : '▶ 自动旋转'}</button>
        </div>
      </div>
      <div className="diagram-box" style={{ minHeight: 500 }}>
        {selectedSystem.hasModel ? (
          <Plot3D
            mode="surface"
            system={selectedSystem}
            allData={allData3D}
            phaseList={phaseList}
            autoRotate={autoRotate}
            selectedPointId={selectedPoint?.id}
            onSelectPoint={(pt) => setSelectedPoint(pt)}
          />
        ) : (
          <div style={{ textAlign: 'center', padding: 60 }}>
            <div style={{ fontSize: 36, marginBottom: 12 }}>⚠</div>
            <div style={{ fontSize: 14, color: 'var(--text-2)', marginBottom: 6 }}>
              该体系尚未训练 PC-CVAE 模型
            </div>
            <div style={{ fontSize: 11, color: 'var(--text-3)' }}>
              无法生成连续相面预测
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
